export default __webpack_public_path__ + "static/media/bg.73d0e633.jpg";